// extracted by mini-css-extract-plugin
export default {"LoadError":"bet_a bhe_qq bhe_a bhe_w bhe_j bhe_q","LoadError__icon":"bet_b bhe_vj bhe_fk bhe_su","LoadError__message":"bet_c bhe_fk bhe_tp"};